// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Common = require("../utils/Common.res.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_HashMap = require("rescript/lib/js/belt_HashMap.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var MM_cmp_proof_node = require("./MM_cmp_proof_node.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.res.js");
var Checkbox = require("@mui/material/Checkbox").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function makeInitialState(wrkCtx, rootStmts) {
  return {
          ctxMaxVar: MM_context.getNumOfVars(wrkCtx) - 1 | 0,
          exprToLabel: Belt_HashMap.fromArray(rootStmts.map(function (stmt) {
                    return [
                            stmt.expr,
                            stmt.label
                          ];
                  }), MM_context.ExprHash)
        };
}

function MM_cmp_proof_tree(props) {
  var rootStmts = props.rootStmts;
  var wrkCtx = props.wrkCtx;
  var settings = props.settings;
  var rootExpr = props.rootExpr;
  var tree = props.tree;
  var match = React.useState(function () {
        return makeInitialState(wrkCtx, rootStmts);
      });
  var state = match[0];
  var match$1 = Local_storage_utils.useStateFromLocalStorageBool("bottom-up-proof-tree-showUnprovedOnly", false);
  var setShowUnprovedOnly = match$1[1];
  var showUnprovedOnly = match$1[0];
  var actSetShowUnprovedOnly = function (newShowUnprovedOnly) {
    setShowUnprovedOnly(function (param) {
          return newShowUnprovedOnly;
        });
  };
  var nodeIdxToLabel = function (idx) {
    var label = Belt_HashMap.get(state.exprToLabel, tree.nodes[idx].expr);
    if (label !== undefined) {
      return label;
    } else {
      return String(idx);
    }
  };
  var intToSym = function (i) {
    if (i <= state.ctxMaxVar) {
      return MM_context.ctxIntToSymExn(wrkCtx, i);
    } else {
      return "&" + String(i);
    }
  };
  var exprToStr = function (expr) {
    return expr.map(intToSym).join(" ");
  };
  var exprToReElem = function (expr) {
    return React.createElement("span", undefined, exprToStr(expr));
  };
  var frmExprToStr = function (asrtLabel, expr) {
    var frame = MM_context.getFrame(wrkCtx, asrtLabel);
    if (frame !== undefined) {
      return MM_context.frmIntsToStrExn(wrkCtx, frame, expr);
    }
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "Cannot find an assertion by label '" + asrtLabel + "'"
          },
          Error: new Error()
        };
  };
  var isRootStmt = function (idx) {
    return Belt_HashMap.has(state.exprToLabel, tree.nodes[idx].expr);
  };
  var getFrmLabelBkgColor = function (label) {
    var frame = MM_context.getFrame(wrkCtx, label);
    if (frame !== undefined) {
      return MM_react_common.getFrmLabelBkgColor(frame, settings);
    }
    
  };
  var rndRootExpr = function () {
    var nodeIdx = tree.nodes.findIndex(function (node) {
          return MM_context.exprEq(node.expr, rootExpr);
        });
    if (nodeIdx !== -1) {
      return React.createElement(MM_cmp_proof_node.make, {
                  tree: tree,
                  nodeIdx: nodeIdx,
                  isRootStmt: isRootStmt,
                  nodeIdxToLabel: nodeIdxToLabel,
                  exprToStr: exprToStr,
                  exprToReElem: exprToReElem,
                  frmExprToStr: frmExprToStr,
                  getFrmLabelBkgColor: getFrmLabelBkgColor,
                  showUnprovedOnly: showUnprovedOnly
                });
    } else {
      return "The proof tree doesn't contain expression [" + exprToStr(rootExpr) + "]";
    }
  };
  var rndControls = function () {
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(React.createElement(FormControlLabel, {
                          control: React.createElement(Checkbox, {
                                checked: showUnprovedOnly,
                                onChange: Expln_React_common.evt2bool(actSetShowUnprovedOnly)
                              }),
                          label: "Show unproved only",
                          style: {
                            marginTop: "-2px",
                            marginLeft: "2px",
                            paddingRight: "10px"
                          }
                        }))
              });
  };
  return React.createElement(Expln_React_Column.make, {
              children: Caml_option.some(null)
            }, rndControls(), rndRootExpr());
}

var make = MM_cmp_proof_tree;

exports.makeInitialState = makeInitialState;
exports.make = make;
/* react Not a pure module */
